/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Mail_Select_PageInputs */

const en_admin_user_list_mail_select_page = /** @type {(inputs: Admin_User_List_Mail_Select_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select or deselect all loaded users`)
};

const de_admin_user_list_mail_select_page = /** @type {(inputs: Admin_User_List_Mail_Select_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle geladenen Nutzer auswählen oder abwählen`)
};

/**
* | output |
* | --- |
* | "Select or deselect all loaded users" |
*
* @param {Admin_User_List_Mail_Select_PageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_mail_select_page = /** @type {((inputs?: Admin_User_List_Mail_Select_PageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Mail_Select_PageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_mail_select_page(inputs)
	return en_admin_user_list_mail_select_page(inputs)
});